
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-center",
      function () {
        return require("private-next-pages/help-center.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-center"])
      });
    }
  